<div
  class="cov-search-bar"
  [ngClass]="advancedMode() ? 'cov-search-bar-advanced' : 'cov-search-bar-basic'"
>
  <mat-form-field>
    <input
      placeholder="{{'search.title'| transloco}}"
      class="cov-search-bar-input"
      matInput
      type="text"
      (focus)="updateState($event)"
      (keyup)="updateState($event); updateSearchTerm($event)"
    />
    @if (!loading()) {
      <cov-icon
        class="cov-search-bar-search-icon mx-2"
        matSuffix
        [iconName]="IconName.SEARCH"
      ></cov-icon>
    } @else {
      <mat-spinner [diameter]="16" color="primary" />
    }
  </mat-form-field>
  @if (modalState()===allStates.INFO) {
    <div class="cov-search-bar-search-info d-flex flex-column gap-3 p-3">
      <!-- <h4>{{'search.dialog.standardSearch'| transloco}}</h4> -->
      <span [innerHTML]="'search.dialog.inputInfoBasic' | transloco"></span>
      @if (false) {
        <!-- Disabled Advanced Search Mode -->
        <cov-divider />
        <mat-checkbox
          [checked]="advancedMode()"
          (click)="$event.stopPropagation()"
          (change)="advancedMode.set($event.checked)"
        >
          {{'search.dialog.advancedSearchMode'| transloco}}
        </mat-checkbox>
        <span [innerHTML]="'search.dialog.inputInfoAdvanced' | transloco"></span>
      }
    </div>
  } @else if (modalState() === allStates.RESULTS) {
    @if (searchResults$ | async; as searchResults) {
      @if (!loading()) {
        <div class="p-4 cov-search-bar-menu">
          @for (group of searchResults.groups; track group) {
            @if (group.filter === 'BASIC') {
              <div class="d-flex gap-1 justify-content-between">
                <h4 [class.mt-4]="!$first">
                  {{'search.dropdown.resultsTo'| transloco}}
                  {{'search.dropdown.searchModeBasic'| transloco}}
                  @if (group.reports.length <= searchMaxLength) {
                    ({{group.reports.length}})
                  }
                </h4>
              </div>

              <ul class="p-0 cov-search-bar-results-list d-flex flex-column gap-4 mb-2">
                <li class="cov-search-bar-results cov-search-bar-results-basic gap-2 py-1">
                  <label
                    class="cov-fs-label"
                    >{{'search.dropdown.group.filter.orderNumber'| transloco}}</label
                  >
                </li>
                @for (report of group.reports; track report) {
                  <li class="cov-search-bar-results cov-search-bar-results-basic gap-2">
                    <a
                      covSearchHighlight
                      [searchTerm]="searchTermWithHighlightUpdate$ | async"
                      [highlightContext]="HIGHLIGHT_CONTEXT"
                      [routerLink]="getOrderItemDetailsLink(report.orderNumber, report.orderPosition)"
                      (click)="setState(SearchModalState.CLOSED)"
                    >
                      <cov-icon class="mr-2" matSuffix [iconName]="IconName.COPY"></cov-icon>
                      {{report.orderNumber }} {{DATA_DIVIDER_SECONDARY}}
                      {{report.orderPosition | removeLeadingZeros}}
                      {{ $any(report)[group.filter]}}
                    </a>
                  </li>
                }
              </ul>
            } @else {
              <div class="d-flex gap-1 justify-content-between">
                <h4 [class.mt-4]="!$first">
                  {{'search.dropdown.resultsTo'| transloco}}
                  {{ 'search.dropdown.group.filter.'+ group.filter | transloco }}
                  @if (group.reports.length <= searchMaxLength) {
                    ({{group.reports.length}})
                  }
                </h4>
                <!-- TODO: More results link will be done in a later revision -->
                <!--
              @if (group.reports.length > searchMaxLength) {
                <a [routerLink]="ordersRoute">
                  {{'search.dropdown.show'| transloco}}
                  {{group.reports.length-searchMaxLength }}
                  {{'search.dropdown.resultsFor'| transloco}}
                  {{ 'search.dropdown.group.filter.'+ group.filter | transloco }}
                </a>
              }
              --></div>
              <ul class="p-0 cov-search-bar-results-list d-flex flex-column gap-4 mb-2">
                <li class="cov-search-bar-results gap-2 py-1">
                  <label
                    class="cov-fs-label"
                    >{{ 'search.dropdown.group.filter.'+ group.filter | transloco }}</label
                  >
                  <label class="cov-fs-label">{{'search.dropdown.productName'| transloco}}</label>
                  <label class="cov-fs-label">{{'search.dropdown.status'| transloco}}</label>
                  <label
                    class="cov-fs-label"
                    >{{'search.dropdown.estimatedDeliveryDate'| transloco}}</label
                  >
                </li>
                @for (report of group.reports; track report) {
                  <li class="cov-search-bar-results gap-2">
                    <a
                      covSearchHighlight
                      [searchTerm]="searchTermWithHighlightUpdate$ | async"
                      [highlightContext]="HIGHLIGHT_CONTEXT"
                      [routerLink]="getOrderItemDetailsLink(report.orderNumber, report.orderPosition)"
                      (click)="setState(SearchModalState.CLOSED)"
                    >
                      <cov-icon class="mr-2" matSuffix [iconName]="IconName.COPY"></cov-icon>
                      @if (group.filter === 'orderNumber' || group.filter === 'docsearch') {
                        {{report.orderNumber}} {{DATA_DIVIDER}}
                        {{report.orderPosition | removeLeadingZeros}}
                      } @else {
                        {{ $any(report)[group.filter]}}
                      }
                    </a>
                    <p>{{report.productName | slice:0:15}} ...</p>
                    <p>{{'enums.orderStatus.' + report.status | transloco | slice:0:10}}</p>
                    <p>{{report.estimatedDeliveryDate | toLocaleDate }}</p>
                  </li>
                }
              </ul>
            }
          }
        </div>
      }
    }
    @if (loading()) {
      <div class="cov-search-bar-search-info d-flex flex-column gap-3 p-3">
        <cov-skeleton [appearance]="SkeletonAppearanceType.HEADLINE"></cov-skeleton>
        <cov-skeleton [appearance]="SkeletonAppearanceType.TEXT" class="mb-0 pb-0"></cov-skeleton>
      </div>
    }
  } @else if (modalState()===allStates.NO_RESULTS) {
    <div class="cov-search-bar-search-info flex-column p-4 gap-3">
      <h4>{{'search.title'| transloco}}</h4>
      <span>{{'search.dialog.noResults' | transloco}}</span>
    </div>
  }
</div>
